import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, booleanAttribute, numberAttribute } from '@angular/core';

@Component({
    selector: 'cs-freespinssummary-icon',
    templateUrl: './freespins-summary-icon.component.html',
    styleUrl: './freespins-summary-icon.component.scss',
    imports: [NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FreeSpinsSummaryIconComponent implements OnInit {
    @Input() freespinscountbg = '';
    @Input({ transform: numberAttribute }) freespinAvailableCount: number;
    @Input({ transform: numberAttribute }) freespinTotalCount: number;
    @Input({ transform: booleanAttribute }) isLegacy = false;
    @Input({ transform: booleanAttribute }) isOptedIn = false;
    isThreeDigit: boolean;

    ngOnInit(): void {
        this.isThreeDigit = this.freespinAvailableCount > 99 || this.freespinTotalCount > 99;
    }
}
